require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-the-local-project-features-one-earle-lane.json") })
        }
      }, "path---journal-the-local-project-features-one-earle-lane");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-the-local-project-features-one-earle-lane!./.cache/json/journal-the-local-project-features-one-earle-lane.json
// module id = 540
// module chunks = 231608221292675